import React, { Component } from 'react'
import { ApolloProvider } from 'react-apollo'
import { Provider } from 'react-redux'
import { client } from 'cogsworth/utils/ApolloClient'
import BookingRouter from 'cogsworth/routing/BookingRouter'
import { createStore } from 'cogsworth/utils/store'
import './BookingApp.css'
import { ApiConfigProvider } from '../../context/api-config'

class BookingApp extends Component {
  componentWillMount() {
    document.title = 'Booking Page'
    document.body.className = 'booking'
    document.documentElement.className = 'booking'
  }

  render() {
    const reduxStore = createStore()

    return (
      <ApolloProvider client={client}>
        <ApiConfigProvider>
          <Provider store={reduxStore}>
            <BookingRouter client={client}/>
          </Provider>
        </ApiConfigProvider>
      </ApolloProvider>
    )
  }
}

export default BookingApp
